/* eslint-disable no-undef */
(function ajaxIndicatorBar($) {
  window.Drupal.Voyager = window.Drupal.Voyager || {};

  $(document)
    .ajaxStart(() => {
      window.Drupal.Voyager.ajaxEventOver = false;

      if (!loadjs.isDefined('nprogress')) {
        const themePath = `/themes/custom/rutherford`;

        // We lazyload the CSS and JS for the AJAX progress bar at the top
        // of the screen on the first ajaxStart event for each page. Otherwise
        // we'd be sending the CSS and JS to all users, even if they never made
        // an AJAX request.
        loadjs(
          [
            `${themePath}/libraries/nprogress/nprogress.css`,
            `${themePath}/libraries/nprogress/nprogress.js`,
          ],
          'nprogress',
          {
            success() {
              console.log('loadjs success');
              NProgress.configure({ showSpinner: false });
            },
          },
        );
      }

      loadjs.ready('nprogress', {
        success() {
          // There's a risk that by the time we have lazyloaded NProgress
          // and started it, the AJAX event will have already completed (or
          // errored!) and so our calls to NProgress.done() in the ajaxComplete
          // and ajaxError events won't do anything. We try to prevent that by
          // checking for the Drupal.Voyager.ajaxEventOver boolean.
          if (!window.Drupal.Voyager.ajaxEventOver) {
            NProgress.start();
          }
        },
      });
    });

  $(document)
    .ajaxComplete(() => {
      window.Drupal.Voyager.ajaxEventOver = true;
      if (typeof NProgress !== 'undefined') {
        NProgress.done();
        NProgress.remove();
      }
    });

  $(document)
    .ajaxError(() => {
      window.Drupal.Voyager.ajaxEventOver = true;
      if (typeof NProgress !== 'undefined') {
        NProgress.done();
        NProgress.remove();
      }
    });
})(jQuery);
